import { useEffect, useState } from "react";
import type { ViewportProfile } from "../types";

function readProfile(): ViewportProfile {
  if (window.innerWidth < 700) return "mobile";
  if (window.innerWidth < 1100) return "tablet";
  return "desktop";
}

export function useViewportProfile(): ViewportProfile {
  const [profile, setProfile] = useState<ViewportProfile>(readProfile);
  useEffect(() => {
    const update = () => setProfile(readProfile());
    window.addEventListener("resize", update, { passive: true });
    return () => window.removeEventListener("resize", update);
  }, []);
  return profile;
}
